import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.staffGrossSales.dataPoints);

  if (!dataPoints?.length) return null;

  const [total, ...restDataPoints] = dataPoints;

  return (
    <div className="section">
      <div className="data-points">
        <div className="data-point">
          <DataDisplay
            label={total.label}
            value={total.value}
            url={total.url}
            currency={total.currency}
            type="money"
          />
        </div>
      </div>
      <div className="data-points">
        {restDataPoints.map((dataPoint) => (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay {...dataPoint} currency={total.currency} type="money" />
          </div>
        ))}
      </div>
    </div>
  );
});

export default DataPoints;
